import { faqItems } from '@/mocks/homeData';

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1024px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block text-xs font-medium text-accent-600 bg-accent-100/70 px-3 py-1 rounded-full mb-3">
            帮助中心
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">常见问答</h2>
          <p className="text-sm text-foreground-600 mt-2">关于黑料吃瓜网的常见问题与解答</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {faqItems.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6"
            >
              <h3 className="text-base font-semibold text-foreground-900 mb-2 flex items-start gap-2">
                <span className="text-primary-500 font-bold shrink-0">Q:</span>
                {item.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed flex items-start gap-2">
                <span className="text-accent-500 font-bold shrink-0">A:</span>
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}